import Controller from '../components/Controller';
import IDHighlight from './IDHighlight';
import FeedbackController from '../feedback/FeedbackController';
import Util from '../common/Util';
// import EventController from '../../common/EventController';

/**
 * 高亮模块控制器,负责管理所有被高亮的对象。
 * 统一管理要素的高亮和取消高亮，清除高亮等操作.
 */
export default class IDHighlightController extends Controller {
    /**
     * 初始化构造函数,设置高亮模块引用的反馈操作对象，高亮要素容器.
     * @return {}
     */
    constructor() {
        super();

        // this.eventController = EventController.getInstance();
        this.highlightItems = {};
    }

    /**
     * 将数据源控制器添加到地图对象中
     * @param {Object}      map map对象
     * @returns {undefined}
     */
    // addTo(map) {
    //     map.idHighlightController = this;
    //     this.map = map;

    //     this.feedbackController = this.map.feedbackController;
    //     this.map.getLeafletMap().on('TileLayersLoaded', this.refresh, this);
    // }

    /**
     * 高亮指定的id
     * @param {Object || Array} value - 需要高亮的id等信息,可以是单个对象或者数组
     * @param {Object} options - 控制本次高亮所使用的的反馈
     * @return {null | string}.
     */
    highlight(value, options = {}) {
        if (!value) {
            return null;
        }

        const key = Util.uuid();

        const highlight = new IDHighlight(this.map, value, options);
        highlight.highlight();
        this.highlightItems[key] = highlight;
        this.feedbackController.add(highlight.feedback);
        this.feedbackController.refresh();
        return key;
    }

    /**
     * 清除指定的id的高亮效果
     * @param {string} key - 参数为highlight方法的返回的key
     * @return {undefined}.
     */
    unHighlight(key) {
        if (!key) {
            return;
        }

        const highlight = this.highlightItems[key];
        if (!highlight) {
            return;
        }

        this.feedbackController.del(highlight.feedback);
        this.feedbackController.refresh();
        delete this.highlightItems[key];
    }

    /**
     * 清除所有的高亮要素.
     * @return {undefined}.
     */
    clearHighlight() {
        const keys = Object.getOwnPropertyNames(this.highlightItems);
        keys.forEach(key => {
            const highlight = this.highlightItems[key];
            this.feedbackController.del(highlight.feedback);
            delete this.highlightItems[key];
        });

        this.feedbackController.refresh();
    }

    /**
     * 判断是否存在高亮要素
     * @returns {boolean}.
     */
    isEmpty() {
        const keys = Object.getOwnPropertyNames(this.highlightItems);
        return keys.length === 0;
    }

    /**
     * 刷新高亮效果.
     * @return {undefined}
     */
    refresh() {
        const keys = Object.getOwnPropertyNames(this.highlightItems);
        keys.forEach(key => {
            const highlight = this.highlightItems[key];
            highlight.highlight();
        });

        this.feedbackController.refresh();
    }

    /**
     * 销毁单例对象.
     * @returns {undefined}
     */
    destroy() {
        this.map.getLeafletMap().off('TileLayersLoaded');
        IDHighlightController.instance = null;
    }
}
